import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';
import { Observable } from 'rxjs';

import { environment } from '../../environments/environment';
import { AuthenticationService } from '../services/authentication.service';


@Injectable()
export class JwtInterceptor implements HttpInterceptor {
    constructor(private authenticationService: AuthenticationService) { }

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        // add auth header with jwt if user is logged in and request is to the api url
       // const currentUser = this.authenticationService.currentUserValue;
       //console.log("this.authenticationService",this.authenticationService)
      // console.log("this.isLoggednIn",this.authenticationService.isLoggednIn())
     //   const isLoggedIn = currentUser && currentUser.token;
       // const isApiUrl = request.url.startsWith(environment.apiUrl);
       // if (this.authenticationService.isLoggednIn() && isApiUrl) {
        //console.log("this.authenticationService.isLoggednIn()",this.authenticationService)
        //    console.log("this.authenticationService.isLoggednIn()",this.authenticationService.isLoggednIn())
            if (this.authenticationService.isLoggednIn() ) {
            request = request.clone({
                setHeaders: {
                    Authorization: `Bearer ${this.authenticationService.getToken()}`,
                    // 'Access-Control-Allow-Origin': '*',
                    // 'Content-Type': 'application/json',
                }
            });
            //console.log("JwtInterceptor",`Bearer ${this.authenticationService.getToken()}`)
        }

        return next.handle(request);
    }
}